import api from "api";

export const fetchPlans = () => api.get("/plan");
export const createPlan = (data) => api.post("/plan", data);
export const searchPlanByType = (data) => api.post("/plan/searchByType", data);

export const fetchPlanTypes = () => api.get("/planTypes");
